import { layout as themeLayout } from '../../../theme/theme.create';
import { colors } from '../../../theme/tokens/colors';
import { radius, radiusPx } from '../../../theme/tokens/radius';
import { shadows } from '../../../theme/tokens/shadows';
import { controlHeights } from '../../../theme/tokens/spacing';

export const horizontalBleed = {
  mx: 0,
  width: '100%',
};

export const CONTENT_HEIGHT = `calc(100vh - ${themeLayout.headerHeight})`;

export function createSharedInputRoot({ chat, typography }) {
  return {
    borderRadius: radiusPx.md,
    fontSize: typography.fontSizeMd || '14px',
    minHeight: controlHeights.md,
    '& fieldset': { borderColor: chat.divider },
    '&:hover fieldset': { borderColor: chat.primaryBorder },
    '&.Mui-focused fieldset': {
      borderColor: chat.primary,
      borderWidth: 1,
    },
  };
}

export function createCompactInputRoot({ chat, typography }) {
  return {
    ...createSharedInputRoot({ chat, typography }),
    minHeight: controlHeights.sm,
    fontSize: typography.fontSizeSm || '13px',
  };
}

export function compactInputLabelSx(chat, typography) {
  return {
    fontSize: typography.fontSizeXs || '12px',
    color: chat.textSecondary,
    '&.Mui-focused': { color: chat.primary },
  };
}

export function compactInputTextSx(typography) {
  return {
    py: 0.5,
    fontSize: typography.fontSizeSm || '13px',
  };
}

export function disabledSurface(chat) {
  return chat.primaryMuted;
}

export function subtleSurface(chat) {
  return chat.userList?.itemHoverBackground || chat.primarySurface;
}

export { colors, radius, radiusPx, shadows, controlHeights };
